import { PublicClientApplication } from '@azure/msal-browser';
import Vue from 'vue'
import CalendarApiService from "@/services/calendarService";
import i18n from '../i18n';
import Store from '@/state/store'

export default class MsalBrowserUtil {
  tenant = "webcab.onmicrosoft.com";

  msalConfig = {
    auth: {
      //redirectUri: "http://localhost:8080",
      authority: "https://webcab.b2clogin.com/webcab.onmicrosoft.com/B2C_1_Signin",
      knownAuthorities: ["webcab.b2clogin.com"]
      //postLogoutRedirectUri: "your_app_logout_redirect_uri"
    },
    cache: {
      cacheLocation: 'sessionStorage',
    },
  };

  accountId = "";
  currentAccount = null;

  accessToken = "";
  idToken = "";
  msalInstance = {};

  scopes = ["https://webcab.onmicrosoft.com/a4a4be7a-fee8-492c-8474-dffa0d6252c0/rw"]

  tokenRequest = {
    scopes: this.scopes
  }

  loginRequest = {
    scopes: this.scopes,
    extraQueryParameters: { ui_locales: i18n.locale }
  }

  passwordResetRequest = {
    scopes: this.scopes,
    authority: 'https://webcab.b2clogin.com/tfp/webcab.onmicrosoft.com/B2C_1_PasswordReset',
    extraQueryParameters: { ui_locales: i18n.locale }
  }

  constructor(redirectUrl, clientId) {
    this.msalConfig.auth.redirectUri = redirectUrl;
    this.msalConfig.auth.clientId = clientId;

    this.msalInstance = new PublicClientApplication(this.msalConfig);
  }

  async init(authRequired) {
    try {
      let response = await this.msalInstance.handleRedirectPromise();
      await this.handleResponse(response, authRequired);
    } catch(response) {
      if (response.errorMessage.includes("AADB2C90118")) {
        await this.msalInstance.loginRedirect(this.passwordResetRequest);
      } else if (response.errorMessage.includes("AADB2C90091")) { // password reset cancelled by user
        await this.msalInstance.loginRedirect(this.loginRequest);
      } else {
        throw response;
      }
    }
  }

  login() {


  }

  logout() {
    Vue.prototype.trackEvent("Logout");
    let logoutRequest = {
      account: this.msalInstance.getAccountByHomeId(this.accountId)
    }
    this.msalInstance.logoutRedirect(logoutRequest);
  }

  setAccountData(data) {
    const currentAccounts = this.msalInstance.getAllAccounts();
    this.accountId = currentAccounts[0].localAccountId;
    this.currentAccount = currentAccounts[0];
    this.accessToken = data.accessToken;
    this.idToken = data.idToken;

    Vue.prototype.setAuthenticatedUserContext(this.currentAccount.username, data.idTokenClaims.extension_OrganisationCode);
  }

  async getToken() {
    let currentAccounts = this.msalInstance.getAllAccounts();
    let request = {
      scopes: this.scopes,
      account: currentAccounts
    }
    try {
      let response = await this.msalInstance.acquireTokenSilent(request)
      this.setAccountData(response);
      return response.accessToken;
    } catch {
      await this.msalInstance.loginRedirect(this.loginRequest);
    }
  }

  async getOrganisationApiToken() {
    let currentAccounts = this.msalInstance.getAllAccounts();
    let request = {
      scopes: ["https://webcab.onmicrosoft.com/348aabfb-cce8-42b8-b603-4668b98102d7/DocumentationConfiguration"],
      account: currentAccounts
    }
    try {
      let response = await this.msalInstance.acquireTokenSilent(request)
      return response.accessToken;
    } catch (error) {
      await this.msalInstance.loginRedirect(this.loginRequest);
    }
  }

  async loadCache() {
    if(this.currentAccount !== null && this.currentAccount !== undefined) {
      let prom1 = Store.dispatch('calendar/fetchAlerts');
      await Promise.all([prom1])
    }
  }

  async setTokenResponse(response) {
    this.setAccountData(response);
    await this.loadCache();
    Object.assign(Vue.prototype.$axiosMainClient.defaults, { headers: { authorization: "Bearer " + this.accessToken } });
    var userConfigResponse = await CalendarApiService.getUserConfig(this.accountId);
    Store.commit('calendar/setUserConfig', userConfigResponse.data.data);
  }

  handleResponse = async (response, authRequired) => {
    if (response !== null) {
      await this.setTokenResponse(response);
      Vue.prototype.trackEvent("Login");
    } else {
      const currentAccounts = this.msalInstance.getAllAccounts();

      if (currentAccounts.length === 0 && authRequired) {
        // no accounts signed-in, attempt to sign a user in
        await this.msalInstance.loginRedirect(this.loginRequest);
      } else if (currentAccounts.length > 1) {
        // Add choose account code here
      } else if (currentAccounts.length === 1) {
        let request = this.msalInstance.SilentRequest = {
          scopes: this.scopes,
          account: currentAccounts,
          forceRefresh: authRequired
        };
        try {
          let response =  await this.msalInstance.acquireTokenSilent(request);
            await this.setTokenResponse(response);
        } catch {
          await this.msalInstance.loginRedirect(this.loginRequest);

        }
      }
    }
  }
}